import { useCallback, useMemo } from 'react'
import { generateClient } from 'aws-amplify/api'

import {
  mergeTeams as mergeTeamsMutation,
  cognitoUpdateUser as cognitoUpdateUserMutation,
} from '../graphql/mutations'

export const useMerge = () => {
  const client = useMemo(() => generateClient(), [])
  const mergeTeams = useCallback(
    async (teamOneId, teamTwoId, offeringId, year) => {
      return client.graphql({
        query: mergeTeamsMutation,
        variables: {
          input: {
            teamOneId,
            teamTwoId,
            offeringId,
            year,
          },
        },
      })
    },
    [client],
  )

  const moveTeam = useCallback(
    (groupName, userId, newUserId) => {
      const userName = `${groupName}${userId}`

      return client.graphql({
        query: cognitoUpdateUserMutation,
        variables: {
          input: { userName, newUserId },
        },
      })
    },
    [client],
  )

  return {
    mergeTeams,
    moveTeam,
  }
}
